import { Pipe, PipeTransform } from '@angular/core';
import { IClientSignField } from '../model/sign-field.model';
import { ITxFormClientData } from '../model/transaction-form-data.model';
import { SignersService } from '../services/signers.service';

@Pipe({
  name: 'filterSignFieldsBySigner',
})
export class FilterSignFieldsBySignerPipe implements PipeTransform {
  constructor(private signersService: SignersService) {}

  transform(signFields: IClientSignField[], signer: ITxFormClientData): IClientSignField[] {
    return this.signersService.getSignFieldsForSigner(signer, signFields);
  }
}
